import React, { useEffect, useState } from "react"
import { Select, Spin } from "antd"
import { useSetState } from "react-use"
import { debounce } from "lodash"
import { getProducts } from "~/services/apis"

const DEFAULT_PARAMS = {
  limit: 10,
  page: 1,
  search: "",
}

const ProductSelect = ({
  className,
  multiple = false,
  value = null,
  onChange = () => {},
  excludes = [],
  allowClear = true,
}) => {
  const [params, setParams] = useSetState({ ...DEFAULT_PARAMS })
  const [products, setProducts] = useState([])
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(false)

  const appendData = async () => {
    setLoading(true)
    try {
      const { data, headers } = await getProducts(params)

      setMeta((headers && JSON.parse(headers.get("meta"))) || {})
      setProducts([
        ...(params.page === 1 ? [] : products),
        ...(data?.products || [])
          ?.filter((product) => !excludes.includes(product?.id))
          ?.map((product) => {
            return {
              label: product?.name,
              value: product?.id,
            }
          }),
      ])
    } catch (e) {
      console.log(e.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    appendData()
    // eslint-disable-next-line
  }, [params])

  const onScroll = (e) => {
    if (
      !loading &&
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight
    ) {
      params.page < meta?.totalPages && setParams({ page: params.page + 1 })
    }
  }

  return (
    <Select
      labelInValue
      value={value}
      showSearch={true}
      notFoundContent={"Không tìm thấy sản phẩm"}
      onPopupScroll={onScroll}
      onSearch={debounce((search) => setParams({ search, page: 1 }), 300)}
      mode={multiple && "multiple"}
      options={products}
      onChange={onChange}
      allowClear={allowClear}
      filterOption={false}
      dropdownRender={(menu) => (
        <>
          {menu}
          {loading && (
            <div className="place-center" style={{ padding: "8px 0" }}>
              <Spin />
            </div>
          )}
        </>
      )}
      onClear={() => onChange(null)}
      className={className}
      placeholder="Chọn sản phẩm"
    />
  )
}

export default ProductSelect
